import * as React from "react";

function SvgIkonaNegativniInformace(props) {
  return (
    <svg
      data-name="Vrstva 1"
      viewBox="0 0 400 400"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M159.91 57.07V48.5h76.28v8.57L216.05 246.5h-36zm3.43 222.86h69.42v68.57h-69.42z" />
    </svg>
  );
}

export default SvgIkonaNegativniInformace;

